var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.12793 8.3735C0.12793 3.8234 3.85074 0.100586 8.40085 0.100586C12.951 0.100586 16.6738 3.8234 16.6738 8.3735C16.6738 12.9236 12.951 16.6464 8.40085 16.6464C3.85074 16.6464 0.12793 12.9236 0.12793 8.3735ZM5.97068 7.02915H4.05757V12.8719H5.97068V7.02915ZM6.12579 5.21945C6.12579 4.65069 5.71215 4.23704 5.03997 4.23704C4.3678 4.23704 3.90245 4.65069 3.90245 5.21945C3.90245 5.78822 4.31609 6.25357 4.98827 6.25357C5.66044 6.25357 6.12579 5.78822 6.12579 5.21945ZM12.951 9.51103C12.951 7.70133 11.9685 6.87404 10.7276 6.87404C9.69349 6.87404 9.22814 7.4428 8.96961 7.85645V7.02915H7.0565C7.0565 7.59792 7.0565 12.8719 7.0565 12.8719H8.96961V9.61444C8.96961 9.45932 8.96961 9.2525 9.02132 9.14909C9.17643 8.78715 9.48667 8.42521 10.0037 8.42521C10.6759 8.42521 10.9861 8.94227 10.9861 9.76956V12.8719H12.8992C12.951 12.8719 12.951 9.51103 12.951 9.51103Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/linkedInIcon.d25728004f1f469f6afac6002732dcec.svg";
export { ForwardRef as ReactComponent };